class Faqs {
    constructor($el) {
        this.$el = $el;
    }

    init() {
        var self = this;

        var $links = $(self.$el).find(
            '.faq-nav-mobile li a, .faq-nav-desktop li a'
        );

        $links.on('click', function (e) {
            e.preventDefault();

            var $this = $(this);
            var hash = $this.prop('hash');
            var selector = hash.replace('#', '.');

            $links.parent().removeClass('active');

            $links
                .filter('[href="' + hash + '"]')
                .parent()
                .addClass('active');

            $(self.$el).find('.faq-panel').hide().filter(selector).show();
        });

        this.initDetailsToggle();
    }

    initDetailsToggle() {
        var self = this;

        $(self.$el)
            .find('details summary')
            .on('click', function () {
                var $clickedDetails = $(this).parent();
                var $allDetails = $(self.$el).find('details');
                
                $allDetails.not($clickedDetails).each(function() {
                    $(this)
                        .removeClass('faq-panel-open')
                        .addClass('faq-panel-closed')
                        .removeAttr('open');
                });
                
                if ($clickedDetails.hasClass('faq-panel-closed')) {
                    $clickedDetails
                        .removeClass('faq-panel-closed')
                        .addClass('faq-panel-open');
                } else {
                    $clickedDetails
                        .removeClass('faq-panel-open')
                        .addClass('faq-panel-closed');
                }
            });
    }
}

(function () {
    'use strict';

    [...document.querySelectorAll('.mol-faqs')].forEach(($el) => {
        const inst = new Faqs($el);
        inst.init();
    });
})();
